// extracted by mini-css-extract-plugin
export var root = "Logo-module--root--Rg4MG";
export var homepageStyle = "Logo-module--homepageStyle--lkngW";
export var defaultLogo = "Logo-module--defaultLogo--UlPjU";
export var homepageScrolled = "Logo-module--homepageScrolled--nscCS";